module.exports = __webpack_public_path__ + "fonts/dm-sans-v6-latin-500.fde3d01.woff2";